import { $t } from '@/i18n';
import { defineComponent } from '@vue/composition-api';
import useApproval from '@/pages/notification/useApproval';
import { Bell } from 'lucide-vue';
export default defineComponent({
    name: 'NotificationEntry',
    methods: {
        handleMenuClick({ key }) {
            this.$router.push(key);
        },
        handleBellClick() {
            const target = '/notifications/approvals';
            if (this.$route?.path !== target) {
                this.$router.push(target);
            }
        },
    },
    setup() {
        const { getTodoCount, todoCount } = useApproval();
        return { getTodoCount, todoCount };
    },
    created() {
        this.getTodoCount();
    },
    render() {
        const triggerEl = (<div class="flex items-center justify-center cursor-pointer hover:text-[#1E304A]" wj-eid={$t('k_5aa48296')} onClick={this.handleBellClick}>
        {this.todoCount > 0 ? (<t-tooltip content={$t('k_97f497d6', { arg_0: this.todoCount })}>
            <t-badge count={this.todoCount} dot style={{ lineHeight: 0 }}>
              <Bell size={16}/>
            </t-badge>
          </t-tooltip>) : (<Bell size={16}/>)}
      </div>);
        return (<a-dropdown trigger={['hover']} placement="bottomRight">
        <a-menu slot="overlay" onClick={this.handleMenuClick}>
          <a-menu-item key="/notifications/approvals" wj-eid={$t('k_29d5a22d')}>
            {this.todoCount > 0 ? (<t-badge count={this.todoCount} dot offset={[6, 6]}>
                <span>{$t('k_29d5a22d')}</span>
              </t-badge>) : (<span>{$t('k_29d5a22d')}</span>)}
          </a-menu-item>
          <a-menu-item key="/notifications/process" wj-eid={$t('k_3e19f854')}>
            <span>{$t('k_3e19f854')}</span>
          </a-menu-item>
        </a-menu>
        {triggerEl}
      </a-dropdown>);
    },
});
